import React, { useState, useEffect } from 'react';
import { BarChart3, Users, Calendar, TrendingUp } from 'lucide-react';
import UserActivityDashboard from '../../dashboard/UserActivityDashboard';

const DashboardPage = () => {
  const [statistics, setStatistics] = useState({
    activeJobs: 0,
    totalCandidates: 0,
    weeklyInterviews: 0,
    offerAcceptance: 0
  });

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    // Get user data from localStorage
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      setUserId(user.id); // or user._id depending on your user object structure
      setUserName(user.name || user.email); // Fallback to email if name isn't available
    }

    // Set statistics
    setStatistics({
      activeJobs: 6,
      totalCandidates: 180,
      weeklyInterviews: 12,
      offerAcceptance: 85
    });
  }, []);

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>
      </div>

      {/* User Activity Dashboard Integration */}
      <div className="bg-white rounded-xl shadow">
        <div className="p-6 border-b">
          <h2 className="text-lg font-semibold">Detailed Activity Analysis</h2>
        </div>
        {userId && userName ? (
          <UserActivityDashboard
            userId={userId}
            userName={userName}
          />
        ) : (
          <div className="p-6 text-center text-gray-500">
            Loading user data...
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardPage;